//https://github.com/vue-generators/vue-form-generator/blob/master/src/utils/validators.js
const errorMessages = {
  fieldIsRequired: "This field is required!",
  invalidFormat: "Invalid format!",

  numberTooSmall: "The number is too small! Minimum: {0}",
  numberTooBig: "The number is too big! Maximum: {0}",
  invalidNumber: "Invalid number",

  textTooSmall: "The length of text is too small! Current: {0}, Minimum: {1}",
  textTooBig: "The length of text is too big! Current: {0}, Maximum: {1}",
  thisNotText: "This is not a text!",

  thisNotArray: "This is not an array!",
  emptyArray: "This field can not be empty!",
  arrayTooSmall: "The length of array is too small! Current: {0}, Minimum: {1}",
  arrayTooBig: "The length of array is too big! Current: {0}, Maximum: {1}",

  selectMinItems: "Select minimum {0} items!",
  selectMaxItems: "Select maximum {0} items!",

  invalidDate: "Invalid date!",
  dateIsEarly: "The date is too early! Current: {0}, Minimum: {1}",
  dateIsLate: "The date is too late! Current: {0}, Maximum: {1}",

  invalidEmail: "Invalid e-mail address!",
  invalidURL: "Invalid URL!"
};

function formatMessage(text) {
  if (text !== null && arguments.length > 1) {
    for (let i = 1; i < arguments.length; i++) {
      text = text.replace("{" + (i - 1) + "}", arguments[i]);
    }
  }
  return text;
}

const rules = {
  isEmpty(value) {
    // checks if `value` is `null` or `undefined` or empty string
    return value === null || value === undefined || value === "";
  },

  isFiniteNumber(value) {
    return typeof value === "number" && isFinite(value);// To exclude `Infinity`, `-Infinity`, and `NaN` which are classified as numbers
  },

  checkEmpty(value, field) {
    if (rules.isEmpty(value)) {
      if (field && field.required) {
        return errorMessages.fieldIsRequired;
      } else {
        return "";
      }
    }
    return null;
  }
};

export default {
  isNumber(value, field = {}) {
    field = field || {};
    const errorMessage = rules.checkEmpty(value, field);
    if (errorMessage !== null) {
      return errorMessage || null;// if empty returning ""
    }
    if (!rules.isFiniteNumber(value)) {
      return errorMessages.invalidNumber;
    }
    if (rules.isFiniteNumber(field.min) && value < field.min) {
      return field.customErrorMessage || formatMessage(errorMessages.numberTooSmall, field.min);
    }
    if (rules.isFiniteNumber(field.max) && value > field.max) {
      return field.customErrorMessage || formatMessage(errorMessages.numberTooBig, field.max);
    }
    return null;
  },
 
  isTimestamp(value, field = {}) {
    field = field || {};
    const errorMessage = rules.checkEmpty(value, field);
    if (errorMessage !== null) {
      return errorMessage || null;// if empty returning ""
    }
    // timestamp can be a a type of string. In that case convert it to number
    value = +value;
    if (!rules.isFiniteNumber(value)) {
      return errorMessages.invalidDate;
    }
    if (rules.isFiniteNumber(field.min) && value < field.min) {
      return formatMessage(errorMessages.dateIsEarly, value, field.min);
    }
    if (rules.isFiniteNumber(field.max) && value > field.max) {
      return formatMessage(errorMessages.dateIsLate, value, field.max);
    }
    return null;
  },

  isString(value, field = {}) {
    const errorMessage = rules.checkEmpty(value, field);
    if (errorMessage !== null) {
      return errorMessage || null;// if empty returning ""
    }
    if (typeof value !== "string") {
      return errorMessages.thisNotText;
    }
    const len = value.length;
    if (rules.isFiniteNumber(field.min) && len < field.min) {
      return formatMessage(errorMessages.textTooSmall, len, field.min);
    }
    if (rules.isFiniteNumber(field.max) && len > field.max) {
      return formatMessage(errorMessages.textTooBig, len, field.max);
    }
    return null;
  },

  isPattern(value, field = {}) {
    if(field.trim){
      value=value.trim();
    }
    const errorMessage = rules.checkEmpty(value, field);
    if (errorMessage !== null) {
      return errorMessage || null;// if empty returning ""
    }
    
    if (!rules.isEmpty(field.pattern)) {
      const reg = new RegExp(field.pattern);
      if (!reg.test(value)) {
        return field.customErrorMessage || errorMessages.invalidFormat;
      }
    }
   
    return null;
  },

  isEmail(value, field = {}) {
    const errorMessage = rules.checkEmpty(value, field);
    if (errorMessage !== null) {
      return errorMessage || null;// if empty returning ""
    }
    const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line no-useless-escape
    if (!reg.test(value)) {
      return field.customErrorMessage || errorMessages.invalidEmail;
    }
    return null;
  },

  isUrl(value, field = {}) {
    const errorMessage = rules.checkEmpty(value, field);
    if (errorMessage !== null) {
      return errorMessage || null;// if empty returning ""
    }
    const reg = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/g; // eslint-disable-line no-useless-escape
    if (!reg.test(value)) {
      return field.customErrorMessage || errorMessages.invalidURL;
    }
    return null;
  },

  isArray(value, field = {}, reportForm) {
    field = field || {};

    const errorMessage = rules.checkEmpty(value, field);
    if (errorMessage !== null) {
      return errorMessage || null;// if empty returning ""
    }
    if (value.constructor.name !== "Array") {
      return errorMessages.thisNotArray;
    }
    const len = value.length;

    if (!field.hasOwnProperty('extendValue')) {

      if (!len && rules.isFiniteNumber(field.min) && field.min > 0) {
        return errorMessages.emptyArray;
      }
      if (rules.isFiniteNumber(field.min) && len < field.min) {
        return formatMessage(errorMessages.arrayTooSmall, len, field.min);
      }
      if (rules.isFiniteNumber(field.min) && len > field.max) {
        return formatMessage(errorMessages.arrayTooBig, len, field.max);
      }
    }
    
    if (field.hasOwnProperty('extendValue')) {
      // eslint-disable-next-line eqeqeq
      if (field.extendValue == reportForm.extendWith && !len && rules.isFiniteNumber(field.min) && field.min > 0) {
        return errorMessages.emptyArray;
      }
      // eslint-disable-next-line eqeqeq
      if (field.extendValue == reportForm.extendWith && rules.isFiniteNumber(field.min) && len < field.min) {
        return formatMessage(errorMessages.arrayTooSmall, len, field.min);
      }
    }
    return null;
  },

  isDate(value, field = {}) {
    field = field || {};
    const errorMessage = rules.checkEmpty(value, field);
    if (errorMessage !== null) {
      return errorMessage || null;// if empty returning ""
    }
    value = new Date(value); // convert string dates to timestams
    field.min = new Date(field.min); //
    field.max = new Date(field.max); //
    value = +value;
    if (!rules.isFiniteNumber(value)) {
      return errorMessages.invalidDate;
    }
    if (rules.isFiniteNumber(field.min) && value < field.min) {
      return formatMessage(errorMessages.dateIsEarly, value, field.min);
    }
    if (rules.isFiniteNumber(field.max) && value > field.max) {
      return formatMessage(errorMessages.dateIsLate, value, field.max);
    }
    return null;
  }
};